import { render, staticRenderFns } from "./MemberRoles.vue?vue&type=template&id=5bd6343b&"
import script from "./MemberRoles.vue?vue&type=script&lang=js&"
export * from "./MemberRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports